module.exports = __webpack_public_path__ + "static/img/banaer.4078f6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banaer.jpg
// module id = U8F3
// module chunks = 121